@use 'themes/westfield' as *;
// Form error messages
// ===================

@use 'tools/dirg' as *;
@use 'tools/color' as *;
@use 'tools/typography.module' as *;

.ErrorMessage {
  display: block;
  color: color('Error');
}

.ErrorMessageDefault {
  @include font-size(1);

  @extend .bodyFont;
  margin-top: units(0.5);
}

.ErrorMessageSmall {
  @extend .paragraphSmall;
  margin-top: units(0.5);
}
